import { ExpenseTagColorEnum } from "@finway-group/shared/lib/models"
import React from "react"
import { useTranslation } from "react-i18next"
import { TagSection } from "~Components/TagSection"
import { useIsPurchaseOrderEnabled } from "~Shared/hooks/featureFlags.hooks"
import { NotificationService } from "~Shared/services"
import { useTags } from "../hooks/useTags.hook"

interface PurchaseOrderTagsProps {
    purchaseOrderTags: Array<string>
    onTagChange?: (tagId: string, detach: boolean) => void
    hideButton?: boolean
    hideTags?: boolean
}

const MAX_TAGS = 2

export const PurchaseOrderTags = ({ purchaseOrderTags, onTagChange, hideButton = false, hideTags = false }: PurchaseOrderTagsProps) => {
    const { t } = useTranslation()
    const { createTag, deleteTag } = useTags()
    const isPurchaseOrderEnabled = useIsPurchaseOrderEnabled()

    const handleTagCreate = async (tagColor: ExpenseTagColorEnum, tagName: string) => {
        try {
            await createTag(tagName, tagColor, {
                onSuccess: (created) => {
                    if (onTagChange) {
                        onTagChange(created._id, false)
                    }
                },
            })
        } catch (err) {
            NotificationService.showErrorNotificationBasedOnResponseError(err, t("error:expense_tag.create.title"))
        }
    }

    const handleTagDelete = async (expenseTagId: string) => {
        try {
            await deleteTag(expenseTagId)
            if (onTagChange) {
                onTagChange(expenseTagId, true)
            }
        } catch (err) {
            NotificationService.showErrorNotificationBasedOnResponseError(err, t("error:expense_tag.delete.title"))
        }
    }

    const handleTagSelected = async (expenseTagId: string) => {
        if (onTagChange) {
            onTagChange(expenseTagId, false)
        }
    }

    const handleTagDetach = async (expenseTagId: string) => {
        if (onTagChange) {
            onTagChange(expenseTagId, true)
        }
    }

    return (
        <div className="flex flex-row gap-4">
            <TagSection
                entityTags={purchaseOrderTags}
                hideButton={hideButton}
                hideTags={hideTags}
                isDeleteAllowed={isPurchaseOrderEnabled}
                maxTags={MAX_TAGS}
                onTagCreate={handleTagCreate}
                onTagDelete={handleTagDelete}
                onTagSelected={handleTagSelected}
                onTagDetach={handleTagDetach}
            />
        </div>
    )
}
